export default function initProfile() {
    let changeBtn = document.querySelector('.profile__change')
    if(changeBtn) {
        changeBtn.addEventListener('click', () => {
            changeBtn.classList.add('hide')
            changeBtn.parentNode.querySelector('.profile__change-pass').classList.add('active')
        })
    }
}